// ** Third Party Components
import styled, { css } from "styled-components";

// ** Custom Components
import { ButtonPrimary } from "components/layout/Button/ButtonPrimary";

// ####################################################

export const StyledAttachmentRemove = styled(ButtonPrimary)`
	width: 100%;

	${({ $customMargin }) =>
		$customMargin &&
		css`
			margin: ${$customMargin};
		`};

	svg {
		color: inherit;
		font-size: 80%;
		top: -1px;
		position: relative;
	}
`;

// ####################################################
